import React from 'react';
import GameContainer from './game-container';
import { observer } from 'mobx-react';
import  { Component } from 'react';
import _cool from 'd3-selection-multi';
import TunerSlider from './tuner-slider.js';
import { radius } from '../constants.js';
import styles from './game-style.scss.js';
const borderPad = 20;
@observer
export default class MultiGame extends Component {
  playOriginal = (index) => {
    this.props.store.playFixedAtIndex(index);
  }
  playB = (semitones) => {
    this.props.store.setSemitonesAtIndex(this.props.store.selectedIndex, semitones);
    // second argument here is to not charge the person from slider
    this.props.store.playDetunedAtIndex(this.props.store.selectedIndex, true);
  }
  render() {
    const bottomMargin = this.props.uistore.svgBottomMargin;
    const topMargin = this.props.uistore.svgTopMargin;
    const height = this.props.uistore.height - bottomMargin;
    const width = this.props.uistore.width;
    // 10 is side-button margin
    const centerOffset = width/2 - radius - 40 - 10;
    const samplerCount = this.props.store.fixedSamplers.length;
    const spacer = (height - topMargin - radius) / (samplerCount-1);
    // circles are placed at centers, other svg are not
    const adjustOrigin = radius;
    const circles = this.props.store.fixedSamplers.map( (_, i) => {
      return (
        <g key={`fixed-g-${i}`} transform={`translate(0,${i*spacer})`}>
          <circle key={`fixed-main-${i}`} r={radius}
            className={`circles original-circles circle-${i}`}
            cx="0" cy="0"
            style={styles.circle}
          />
        </g>
      )
    });
    const leftDivs = this.props.store.fixedSamplers.map( (_, i) => {
      const animateString = this.props.store.fixedSamplers[i].isPlaying? `circle-under-${i}` : "";
      return (
        <div key={`fixed-div-${i}`} style={{transform: `translate(${width / 2.0 - centerOffset - 2*radius}px,${i*spacer+topMargin}px)`}}>
          <div key={`fixed-inner-${i}`} className={`circles ${animateString}`} style={{position: 'absolute'}}>
            <svg key={`fixed-svg-${i}`} width={2*radius} height={2*radius}>
              <circle key={`fixed-under-temp-${i}`} r={radius}
                className={`circle-${i}`}
                cx={radius} cy={radius}
                style={styles.circle} />
            </svg>
          </div>
        </div>
      )
    });
    const bentCircles = this.props.store.deTunedSamplers.map( (_, i) => {
      return <g key={`detune-main-${i}`} transform={`translate(0,${i*spacer})`}>
        <circle r={radius}
        className={`circles detuned-circles circle-${i} ` +
        `${this.props.highlightIds.includes("tuned-circle")? "swell-repeat": ""} ` +
        `${i===this.props.store.selectedIndex? "selected-svg-circle" : ""}`}
        cx="0" cy="0"
        style={styles.circle}
      />
        </g>
    });
    const rightDivs = this.props.store.deTunedSamplers.map( (_, i) => {
      const animateString = this.props.store.deTunedSamplers[i].isPlaying? `circle-under-${i}` : "";
      return (
        <div key={`fixed-div-${i}`} style={{transform: `translate(${width / 2.0 + centerOffset-borderPad/2}px,${i*spacer+topMargin-borderPad/2}px)`}}>
          <div key={`fixed-inner-${i}`} className={`circles ${animateString}`} style={{position: 'absolute'}}>
            <svg key={`fixed-svg-${i}`} width={2*radius + borderPad} height={2*radius + borderPad}>
              <circle key={`fixed-under-temp-${i}`} r={radius}
                className={`circle-${i} ` +
                `${i===this.props.store.selectedIndex? "selected-svg-circle" : ""}`}
                cx={radius + borderPad/2} cy={radius + borderPad/2}
                style={styles.circle} />
            </svg>
          </div>
        </div>
      )
    });
    return (
      <GameContainer playAll={this.props.store.playAllFixed} {...this.props}>
        <div>
          <div className="under-controls"
            style={{position: "absolute", overflow: "hidden", pointerEvents: 'none',
              top: 0, left: 0, right: 0, bottom: 0, zIndex: 1}}>
              {leftDivs}
              {rightDivs}
            </div>
            <svg id="game" xmlns="http://www.w3.org/2000/svg" width={width} height={height+bottomMargin}
              style={{position: 'absolute', zIndex: 2}}>
              <g className="master-group" transform={`translate(0,${topMargin})`}>
                <g className="circle-master">
                  <g className="original-pitches"
                    transform={`translate(${width / 2.0 - centerOffset - adjustOrigin}, ${radius})`}>
                    {circles}
                  </g>
                  <TunerSlider width={radius*2}
                    height={height}
                    groupStyle={
                      {transform: `translate(${width / 2 - radius}px, 0px)`}}
                      correctCount={this.props.store.correctCount}
                      range={this.props.store.range}
                      items={this.props.store.items}
                      deTunedSamplers={this.props.store.deTunedSamplers}
                      selectedIndex={this.props.store.selectedIndex}
                      playSelected={this.playB} />
                    <g className="tuned-pitches"
                      transform={`translate(${width / 2.0 + centerOffset + adjustOrigin}, ${radius})`}>
                      {bentCircles}
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </GameContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/multi-game.js